import * as React from "react";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from '@mui/icons-material/Search';
import { useState } from "react";
import DevicesIcon from '@mui/icons-material/Devices';

// Transition for the slide animation
const Transition = React.forwardRef(function Transition(
  props, // No type annotations here
  ref
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const KategoriMerkDialog = ({
  dataMerk,
  openMerk,
  handleCloseMerk,
  onSelect,
}) => {

  const [searchValue, setSearchValue] = useState("");
 
  const filteredMerk = dataMerk.filter((merk) =>
    merk.name.toLowerCase().includes(searchValue.toLowerCase())
  );
  return (
    <Dialog
      fullScreen
      open={openMerk}
      onClose={handleCloseMerk}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
        <IconButton
            edge="end"
            color="inherit"
            onClick={handleCloseMerk}
            aria-label="close"
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography
            sx={{ ml: 2, flex: 1, textAlign: "center" }}
            variant="h6"
            component="div"
          >
           Browse Merk
          </Typography>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: 2, borderRadius: 3, bgcolor: "#f5f5f5", mb: 2 }}>
      <TextField
        fullWidth
        size="small"
        placeholder="Cari Merk Device"
        variant="outlined"
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        sx={{
          bgcolor: "#fff",
          borderRadius: 2,
          mb: 2,
          "& .MuiOutlinedInput-root": {
            borderRadius: 2,
          },
        }}
      />

        {filteredMerk.map((merk, index) => (
        <ListItem
          key={index}
          onClick={() => onSelect(merk)}
          sx={{
            bgcolor: "#fff",
            borderRadius: 2,
            mb: 1,
            boxShadow: 1,
            cursor: "pointer",
            px: 2,
            py: 1.5,
          }}
        >
           <ListItemIcon sx={{ minWidth: 0, mr: 2 }}>
    <DevicesIcon sx={{ bgcolor: "#eee", borderRadius: "50%", padding: 1, fontSize: 32 }} />
  </ListItemIcon>
          <ListItemText
            primary={
              <Typography variant="body2" fontWeight="bold" color="text.primary">
                {merk.name}
              </Typography>
            }
          />
        </ListItem>
      ))}
       
      </Box>
    </Dialog>
  );
};

export default KategoriMerkDialog;
